import { ResponsiveLine } from "@nivo/line";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";

const LineChart = ({ data, isCustomLineColors = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  console.log("Chart Data:", data); // Debugging data format

  return (
    <ResponsiveLine
      data={[
        {
          id: "Requests",
          data: data.map((item) => ({
            x: item.date, // Ensure it's in "YYYY-MM-DD" format
            y: item.count,
          })),
        },
      ]}
      margin={{ top: 50, right: 50, bottom: 60, left: 60 }}
      xScale={{
        type: "time",
        format: "%Y-%m-%d",
        precision: "day",
      }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: false,
        reverse: false,
      }}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: -45,
        legend: "Date",
        legendOffset: 45,
        legendPosition: "middle",
        format: "%b %d", // Formatting dates
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        legend: "Requests",
        legendOffset: -50,
        legendPosition: "middle",
      }}
      theme={{
        axis: {
          ticks: {
            text: {
              fill: theme.palette.mode === "dark" ? "#ffffff" : "#333333",
            },
          },
          legend: {
            text: {
              fill: theme.palette.mode === "dark" ? "#ffffff" : "#333333",
            },
          },
        },
      }}
      colors={isCustomLineColors ? [colors.primary[500]] : { scheme: "category10" }}
      pointSize={8}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      useMesh={true}
    />
  );
};

export default LineChart;
